import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';
import type {AiActionLoadingModalProps} from './ai-action-loading-modal.types';

const PANEL_ID = 'ai-action-loading-panel';

export default function AiActionLoadingModal(): ReactElement {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.AI_ACTION_LOADING_MODAL];
  });

  return (
    <Modal
      modalId={MODALS_IDS.AI_ACTION_LOADING_MODAL}
      modalMaxHeight="fit-content"
      modalHeight="fit-content"
      modalMaxWidth="500px"
      extraRoundedCorners
      panelId={PANEL_ID}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName="ai-action-loading-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export const openAiActionLoadingModal = (props: AiActionLoadingModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.AI_ACTION_LOADING_MODAL,
      panelProps: props,
    })
  );
};
